import {MDCTooltip} from '@material/tooltip';
import {MDCDialog} from '@material/dialog';

const dialog = new MDCDialog(document.querySelector('.mdc-dialog'));
const titleElement = document.getElementById('reading_model_title');
const chapterList = document.getElementById('chapter-list'); // Replace with your container ID
const template = document.getElementById('chapter-list-item-template');

document.querySelectorAll('.mdc-tooltip').forEach(el => {
    const tooltip = new MDCTooltip(el);
});

$(function() {
    $('.chapter_browser').on('click', function (event) {
        const button = $(this);
        const title = button.data('title');
        const num = button.data('num');
        const sources = button.data('sources');
        titleElement.textContent = "Reading Chapter " + num + " from manga " + title
        populateChapterList(sources);
        dialog.open();
    })
});

function populateChapterList(chapters) {
    // Clear the current list
    chapterList.innerHTML = '';
    chapters.forEach((chapter, index) => {
        // Clone the template content
        const chapterItem = template.content.cloneNode(true);

        // Populate the link
        const link = chapterItem.querySelector('.chapter-link');
        link.href = `/manga/${chapter.mangaSlug}/chapter/${chapter.chapterId}`;
        link.querySelector('.chapter-source').textContent = `Source ${index + 1}`;
        link.querySelector('.badge-language').textContent = chapter.sourceLang.toUpperCase();

        // Append the populated item to the list
        chapterList.appendChild(chapterItem);
    });
}
